import type { ZodType } from 'zod'
import * as z from 'zod'

type HexColorValue = string

const HEX_COLOR_REGEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i

type ZodHexColorSchema = ZodType<HexColorValue>

type RefinementCtx<T> = Parameters<Parameters<ZodType<T>['superRefine']>[0]>[1]

function addCustomIssue(ctx: RefinementCtx<HexColorValue>, issue: Record<string, unknown>) {
  ctx.addIssue({
    code: 'custom',
    params: {
      issue,
    },
  })
}

function createZodHexColor(): ZodHexColorSchema {
  return z.custom<HexColorValue>(() => true).superRefine((data, ctx) => {
    const value = data as string | null | undefined

    if (!value) {
      addCustomIssue(ctx, {
        code: 'required',
      })
    }

    if (typeof value !== 'string' || !HEX_COLOR_REGEX.test(value)) {
      addCustomIssue(ctx, {
        code: 'invalid_hex_color',
      })
    }
  })
}

class ZodHexColor {
  static create() {
    return createZodHexColor()
  }
}

declare module 'zod' {
  export function hexColor(): ZodHexColorSchema
}

export { ZodHexColor }
